import React from 'react';
import '../../css/designSystem/OutlinedButton.css';

const OutlinedButton = ({ text, onClick }) => {
  return (
    <button className="outlined-button" onClick={onClick}>
      <div className='help-text burgandy'>{text} </div>
    </button>
  );  
};

export default OutlinedButton;